import { PngDownload as PngDownloadInner } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/Components/PngDownload";
import { BasicDurations } from "app/services/DurationService";

import { getSingleMetricConfig } from "../config/config";
import { useHighLevelMetricsContext } from "../context";

export const PngDownload = ({ chartRef }) => {
    const { selectedMetric, params } = useHighLevelMetricsContext();

    // Use our new config system as fallback if selectedMetric is undefined
    const safeSelectedMetric = selectedMetric || getSingleMetricConfig("monthly-visits");
    const { getTitle } = safeSelectedMetric;

    const { duration } = params;
    const is28d = duration === BasicDurations.LAST_TWENTY_EIGHT_DAYS;
    const metricName = getTitle({ is28d });

    return (
        <PngDownloadInner
            metricName={metricName}
            chartRef={chartRef}
            offset={{ x: 20, y: 50 }}
        />
    );
};
